export default "__VITE_PUBLIC_ASSET__a775cbb9__"